import api from '../api/api'
import { REVISION_KEY } from '@/components/constant'
// eslint-disable-next-line no-unused-vars

export const DEFAULT_DIKE_TRAJECT_DRAWER_WIDTH = 850
export const DEFAULT_PROJECT_SIDEBAR_WIDTH = 60
export const DEFAULT_PROJECT_SIDEBAR_EXPANDED_WIDTH = 250
export const DEFAULT_COMMENT_DRAWER_WIDTH = 550

export const namespaced = true

const baseURI = '/projects/'
const getDefaultState = () => {
  return {
    projects: null,
    projectDialog: false,
    projectDeleteDialog: false,
    currentProject: {
      id: '',
      code: '',
      name: '',
      client: '',
      location: ''
    },
    loading: false,
    writeLoading: false,
    drawer: false,
    schematisationDrawer: false,
    status: 'empty',
    options: null,
    edit: false,
    dikeTrajectDrawerWidth: DEFAULT_DIKE_TRAJECT_DRAWER_WIDTH
  }
}
export const state = getDefaultState()

export const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  ADD_REVISION(state, { parameter, revision }) {
    state.currentProject[parameter].push(revision)
  },
  UPDATE_PROJECT_IN_PROJECTS(state, project) {
    state.projects?.find((existingProject) => {
      if (project.id === existingProject.id) {
        Object.assign(existingProject, project)
      }
    })
  },
  DELETE_PROJECT_IN_PROJECTS(state, projectId) {
    let index = state.projects.findIndex((existingProject) => projectId === existingProject.id)
    if (index !== -1) {
      state.projects.splice(index, 1)
    }
  },
  ADD_PROJECT(state, project) {
    state.projects.push(project)
  },
  TOGGLE_PROJECT_DIALOG(state) {
    state.projectDialog = !state.projectDialog
  },
  TOGGLE_PROJECT_DELETE_DIALOG(state) {
    state.projectDeleteDialog = !state.projectDeleteDialog
  },
  TOGGLE_LOADING(state) {
    state.loading = !state.loading
  },
  TOGGLE_WRITE_LOADING(state) {
    state.writeLoading = !state.writeLoading
  },
  SET_CURRENT_PROJECT(state, currentProject) {
    state.currentProject = currentProject
  },
  SET_CURRENT_PROJECT_PARAMETER(state, currentProjectParameter) {
    let fieldName = Object.keys(currentProjectParameter)[0]
    state.currentProject[fieldName] = currentProjectParameter[fieldName]
  },
  SET_EMPTY_CURRENT_PROJECT(state) {
    let fieldNames = Object.keys(state.currentProject)
    let emptyProject = {}
    fieldNames.forEach((fieldName) => (emptyProject[fieldName] = ''))
    state.currentProject = emptyProject
  },
  TOGGLE_DRAWER(state, bool) {
    if (bool !== null) {
      state.drawer = bool
    } else {
      state.drawer = !state.drawer
    }
  },
  TOGGLE_SCHEMATISATION_DRAWER(state) {
    state.schematisationDrawer = !state.schematisationDrawer
  },
  SET_ACTIVE_DIKE_SECTION(state, dikeSection) {
    dikeSection.active = true
  },
  TOGGLE_DIKE_SECTION(state, dikeSection) {
    dikeSection.active = !dikeSection.active
  },
  TOGGLE_DIKE_PROFILE(state, dikeProfile) {
    dikeProfile.active = !dikeProfile.active
  },
  SET_ACTIVE_DIKE_PROFILE(state, dikeProfile) {
    dikeProfile.active = true
  },
  SET_SELECTED_REVISION(state, { parameter, payload }) {
    state.currentProject.currentprojectuser[parameter] = payload
  },

  SET_SELECTED_SPECKLE_MODEL(state, model_id) {
    state.currentProject.currentprojectuser.selected_speckle_model_id = model_id
  },

  SET_SELECTED_SPECKLE_VERSION(state, version_id) {
    state.currentProject.currentprojectuser.selected_speckle_version_id = version_id
  },

  UPDATE_SELECTED_REVISION(state, { parameter, selectedRevision }) {
    state.currentProject.currentprojectuser[parameter] = selectedRevision
  },
  UPDATE_SELECTED_YEAR(state, payload) {
    state.currentProject.currentprojectuser.selected_year = payload
  },
  SET_OPTIONS(state, options) {
    state.options = options
  },
  SET_UPLOADING_DIKE_PROFILES(state, bool) {
    state.currentProject.uploading_dike_profiles = bool
  },
  TOGGLE_EDIT(state, bool = !state.edit) {
    state.edit = bool
  },
  SET_DIKE_TRAJECT_DRAWER_WIDTH(state, value) {
    state.dikeTrajectDrawerWidth = value
  },
  RESET_DIKE_TRAJECT_DRAWER_WIDTH(state) {
    state.dikeTrajectDrawerWidth = DEFAULT_DIKE_TRAJECT_DRAWER_WIDTH
  }
}
export const actions = {
  resetState({ commit }) {
    commit('resetState')
  },
  toggleLoading({ commit }) {
    commit('TOGGLE_LOADING')
  },
  async fetchProjects({ commit }) {
    commit('TOGGLE_LOADING')
    let response = await api.get(baseURI)
    commit('SET_PROJECTS', response['data'])
    commit('TOGGLE_LOADING')
  },
  async setProjects({ commit }, projects) {
    commit('SET_PROJECTS', projects)
  },
  async fetchProject(context, id) {
    context.commit('TOGGLE_LOADING')
    let url = baseURI + `${id}/`
    let response = await api.get(url)
    context.commit('SET_CURRENT_PROJECT', response['data'])
    if (context.state.currentProject.soiltyperevision_set) {
      let revisionSet = state.currentProject.soiltyperevision_set
      const id = state.currentProject.currentprojectuser[REVISION_KEY.SOIL_TYPE]
      await context.dispatch(
        'soilTypeRevision/setSelectedRevisionById',
        { revisionSet, id },
        {
          root: true
        }
      )
    }
    if (context.state.currentProject.stageconfigurationrevision_set) {
      let revisionSet = state.currentProject.stageconfigurationrevision_set
      const id = state.currentProject.currentprojectuser[REVISION_KEY.STAGE_CONFIGURATION]
      await context.dispatch(
        'stageConfigurationRevision/setSelectedRevisionById',
        { revisionSet, id },
        {
          root: true
        }
      )
    }
    if (context.state.currentProject.waterlinerulerevision_set) {
      let revisionSet = state.currentProject.waterlinerulerevision_set
      const id = state.currentProject.currentprojectuser[REVISION_KEY.WATER_LINE_RULE]
      await context.dispatch(
        'waterLineRuleRevision/setSelectedRevisionById',
        { revisionSet, id },
        {
          root: true
        }
      )
    }
    context.commit('TOGGLE_LOADING')
  },
  async createOrUpdateProject(context, payload) {
    if (payload.id) {
      return await context.dispatch('updateProject', payload)
    } else {
      return await context.dispatch('createProject', payload)
    }
  },
  async createProject(context, payload) {
    context.commit('TOGGLE_WRITE_LOADING')
    try {
      let response = await api.post(baseURI, payload)
      context.commit('ADD_PROJECT', response['data'])
      context.commit('SET_CURRENT_PROJECT', response['data'])
      context.commit('TOGGLE_WRITE_LOADING')
      return response['data']
    } catch (e) {
      context.commit('TOGGLE_WRITE_LOADING')
      console.log(e)
      return false
    }
  },
  async updateProject(context, payload) {
    let url = baseURI + `${payload.id}/`
    let response = await api.patch(url, payload)
    context.commit('UPDATE_PROJECT_IN_PROJECTS', response['data'])
    return response
  },
  async getDikeProfileElevation(context, id) {
    let url = '/dike_profiles/' + `${id}/` + 'get_elevation/'
    await api.get(url)
  },
  updateProjectParameter(context, payload) {
    context.commit('SET_CURRENT_PROJECT_PARAMETER', payload)
  },
  async deleteProject(context) {
    let id = context.state.currentProject.id
    let url = baseURI + `${context.state.currentProject.id}/`
    context.commit('TOGGLE_WRITE_LOADING')
    try {
      await api.delete(url)
      context.commit('DELETE_PROJECT_IN_PROJECTS', id)
    } catch (e) {
      console.log(e)
    }
    context.commit('TOGGLE_WRITE_LOADING')
  },
  async toggleProjectDialog(context, project) {
    context.dispatch('setCurrentProject', project)
    context.commit('TOGGLE_PROJECT_DIALOG')
  },
  toggleDeleteProjectDialog(context, project) {
    context.commit('TOGGLE_PROJECT_DELETE_DIALOG')
    context.dispatch('setCurrentProject', project)
  },
  setCurrentProject(context, project) {
    if (project) {
      context.commit('SET_CURRENT_PROJECT', project)
    } else {
      context.commit('SET_EMPTY_CURRENT_PROJECT')
    }
  },
  toggleDrawer({ commit }, bool = null) {
    commit('TOGGLE_DRAWER', bool)
  },
  toggleEdit({ commit }, bool) {
    commit('TOGGLE_EDIT', bool)
  },
  toggleSchematisationDrawer({ commit }) {
    commit('TOGGLE_SCHEMATISATION_DRAWER')
  },
  addRevision(context, { parameter, revision }) {
    const parameterSetName = context.getters.parameterSetName(parameter)
    context.commit('ADD_REVISION', { parameter: parameterSetName, revision })
  },
  updateRevision(context, payload) {
    context.commit('UPDATE_SELECTED_REVISION', payload)
  },
  updateYear(context, year) {
    context.commit('UPDATE_SELECTED_YEAR', year)
  },
  setActiveDikeSection(context, e) {
    context.commit(
      'SET_ACTIVE_DIKE_SECTION',
      context.rootGetters['dikeSection/getDikeSectionFromEvent'](e)
    )
  },
  toggleDikeSection(context, dikeSection) {
    context.commit('TOGGLE_DIKE_SECTION', dikeSection)
  },
  toggleDikeProfile(context, dikeProfile) {
    context.commit('TOGGLE_DIKE_PROFILE', dikeProfile)
  },
  setUploadingDikeProfiles(context, bool = true) {
    context.commit('SET_UPLOADING_DIKE_PROFILES', bool)
  },
  async setSelectedRevision(context, { parameter, payload }) {
    context.commit('SET_SELECTED_REVISION', { parameter, payload })
  },
  setSelectedSpeckleModel(context, model_id) {
    context.commit('SET_SELECTED_SPECKLE_MODEL', model_id)
  },
  setSelectedSpeckleVersion(context, version_id) {
    context.commit('SET_SELECTED_SPECKLE_VERSION', version_id)
  },
  async updateCurrentProjectUserSpeckle(context) {
    const projectUserId = context.state.currentProject.currentprojectuser.id
    const url = `/project_user/${projectUserId}/`
    const model_id = context.state.currentProject.currentprojectuser.selected_speckle_model_id
    const version_id = context.state.currentProject.currentprojectuser.selected_speckle_version_id
    const data = {
      selected_speckle_model_id: model_id,
      selected_speckle_version_id: version_id
    }
    await api.patch(url, data)
  },
  async fetchOptions({ state, commit }) {
    if (!state.options) {
      const response = await api.options(baseURI)
      commit('SET_OPTIONS', response.data.actions.POST)
    }
  },
  setDikeTrajectDrawerWidth({ commit }, value) {
    commit('SET_DIKE_TRAJECT_DRAWER_WIDTH', value)
  },
  resetDikeTrajectDrawerWidth({ commit }) {
    commit('RESET_DIKE_TRAJECT_DRAWER_WIDTH')
  },
  async fetchUploadUrl(context, blobName) {
    const url = `${baseURI}get_upload_uri/`
    const response = await api.get(url, { params: { blob_name: blobName } })
    return response.data.url
  }
}

export const getters = {
  selectedSoilTypeRevision: (state) => {
    return state.currentProject?.currentprojectuser
      ? state.currentProject.soiltyperevision_set.find(
          (revision) =>
            revision.id === state.currentProject.currentprojectuser.selected_soil_type_revision
        )
      : null
  },
  getRevisionSet: (state) => (parameter) => {
    if (state.currentProject.id) {
      return state.currentProject[parameter]
    }
    return []
  },
  selectedRevision: (state, getters) => (parameter) => {
    const parameterSet = getters.parameterSetName(parameter)
    return state.currentProject?.currentprojectuser
      ? state.currentProject[parameterSet].find(
          (revision) => revision.id === state.currentProject.currentprojectuser[parameter]
        )
      : null
  },
  selectedYear: (state) => {
    return state.currentProject.currentprojectuser
      ? state.currentProject.year_set.find(
          (year) => year.id === state.currentProject.currentprojectuser.selected_year
        )
      : null
  },
  parameterSetName: () => (parameter) => {
    return parameter.replace('selected_', '').replaceAll('_', '') + '_set'
  },
  selectedProjectId: (state) => {
    return state.currentProject.id ? state.currentProject.id : null
  },
  getCurrentRole: (state) => {
    return state.currentProject?.currentprojectuser?.role || null
  },
  sideBarWidth: (state) => {
    return state.drawer ? DEFAULT_PROJECT_SIDEBAR_EXPANDED_WIDTH : DEFAULT_PROJECT_SIDEBAR_WIDTH
  },
  getAllDrawerWidth: (state, getters, rootState) => {
    const showComments = rootState.comment.show
    const commentDrawerWidth = showComments ? DEFAULT_COMMENT_DRAWER_WIDTH : 0
    const rightOffset = state.dikeTrajectDrawerWidth + commentDrawerWidth
    return getters.sideBarWidth + rightOffset + 'px'
  }
}
